import App from "./App.jsx";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { determineLang } from "@/utils/languageUtils";
import { useLangStore } from "@/store/lang-store";
import { setSSRArticle } from "@/store/article-ssr";
import 'react-tooltip/dist/react-tooltip.css';

// Hydrate state from SSR
const initialProps = window.__SSR_DATA__ || {};

// Seed the article SSR store BEFORE deleting window.__SSR_DATA__
// so Article.jsx can read it synchronously as initial useState value.
if (initialProps.article && initialProps.articleSlug) {
  setSSRArticle(initialProps.article, initialProps.articleSlug);
}

// Clear the SSR data from the window object to avoid it being used again
// and to free up memory
if (typeof window !== 'undefined') {
    delete window.__SSR_DATA__;
}

// Sync the zustand lang store BEFORE hydration. Doing it later (inside an effect)
// fires a useSyncExternalStore update while lazy route Suspense boundaries are still
// hydrating, which forces a full client re-render (React error #421).
const detectedLang = determineLang(initialProps?.langCode);
if (detectedLang && useLangStore.getState().langStore !== detectedLang) {
    useLangStore.getState().setLangStore(detectedLang);
}

ReactDOM.hydrateRoot(
  document.getElementById("root"),
  <React.StrictMode>
    {/* {console.log("Main")} */}
    <HelmetProvider>
      <BrowserRouter>
        <App ssrInitialState={initialProps}/>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
  {
    onRecoverableError: (error, errorInfo) => {
      console.warn('[hydration]', error?.message, errorInfo?.componentStack);
    },
  }
);
